export const APPROVE_STATUS = 1;

export const PRESENCE_ACTION_STATE_CONSULT = 'update_consult_status';
export const PRESENCE_ACTION_STATE_READ = 'read';
export const PRESENCE_ACTION_INVITE_DOCTOR = 'invite_2nd_doctor';
export const PRESENCE_ACTION_CONSULT_SERVICE = 'consult_service';
export const PRESENCE_ACTION_SET_MAIN_PROVIDER = 'set_main_doctor_to_consult';
export const PRESENCE_ACTION_PATIENT_DECLINE_DOCTOR = 'patient_declined_doctor';
export const PRESENCE_ACTION_DOCTOR_ACCEPTED_CONSULT = 'doctor_accepted_consult';
export const PRESENCE_ACTION_SWITCH_CLINIC_START = 'switch_clinic_start';
export const PRESENCE_ACTION_SWITCH_CLINIC_COMPLETED = 'switch_clinic_completed';
export const PRESENCE_ACTION_PRESCRIPTION_STATUS_CHANGED = 'prescription_status_changed';

export const MESSAGES_COUNT_PER_PAGE = 20;

export const PAGE_SIZE = 20;

export const SOURCE_REQUEST_OTHER = 5;

export const TAB_PATIENT = 1;
export const TAB_DOCTOR = 2;

export const MAX_DOCTOR_IN_GROUP = 2;

export const AVATAR_COLOR_GROUP = {
  0: {
    background: '#d7ebf8',
    text: '#3398db',
  },
  1: {
    background: '#d6dbdf',
    text: '#34495e',
  },
  2: {
    background: '#fae6d3',
    text: '#e67e22',
  },
  3: {
    background: '#fbdcd8',
    text: '#e95648',
  },
  4: {
    background: '#d1ece7',
    text: '#18a085',
  },
  5: {
    background: '#e6e8e9',
    text: '#7e8c8d',
  },
  6: {
    background: '#d4efe0',
    text: '#28ae60',
  },
  7: {
    background: '#d9d9f4',
    text: '#3e43c7',
  },
  8: {
    background: '#fcdee4',
    text: '#ef5777',
  },
  9: {
    background: '#e9daef',
    text: '#8f46ae',
  },
};

export const CONVERSATION_MODEL_RESPONSE = {
  id: true,
  updated_at: true,
  latest_consult: {
    id: true,
    patient: true,
    for_patient: true,
    doctor_conversation: true,
    priority: true,
    status: true,
    latest_issue: true,
    doctor: true,
    tags: true,
    doctor_uuids: true,
    member_uuids: true,
    doctors: true,
    clinics: true,
    practice_cost: true,
    conversation_id: true,
    doctor_conversation_id: true,
    service: true,
    consult_type: true,
    clinic_id: true,
    // privateConsult
    // memberUuids : use in textComposer
    // poolStatus: consider use in Message Header
    // channel: consider use in MessageBodyPatient, MessageBodyDoctor
    // extraData: use in patient info on right menu
  },
  participant: true,
  channel_id: true, // use channel id for chat
  clinic_id: true,
  type: true,
  is_updating: true,
  updated_by: true,
};

export const CONSULT_COMMONS_MODEL_RESPONSE = {
  id: true,
  service: true,
  patient: true,
  for_patient: true,
  created_at: true,
  status: true,
  extra_data: true,
  is_awaiting_patient_confirmation: true,
};

export const CONSULT_DETAILS_FINISH_CONSULT_MODEL_RESPONSE = {
  id: true,
  total_minutes: true,
  video_call_duration: true,
  patient_message_count: true,
  consult_fee: true,
  health_summary: true,
};
